import { render, staticRenderFns } from "./tester_add.vue?vue&type=template&id=4bf59b0d&"
import script from "./tester_add.vue?vue&type=script&lang=ts&"
export * from "./tester_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports